import React from 'react';
import {getTime} from './countdown';

type ExpiryDataParams = {
    timeDistanceState: number;
};
export const useExpiryData = ({timeDistanceState}: ExpiryDataParams) =>
    React.useMemo(() => {
        const {days} = getTime(timeDistanceState);

        const isCountdownActive = timeDistanceState > 0;
        const hasCountdownJustExpired = timeDistanceState <= 0;
        const isFinalDay = days === 0;

        return {
            isCountdownActive,
            isFinalDay,
            hasCountdownJustExpired
        };
    }, [timeDistanceState]);
